import styled from '@emotion/styled';
import { switchProp } from 'styled-tools';
import { StyledRichText } from '$shared/components/RawHtml/styled';
import { StyledText } from '$shared/components/Text';
import { AlignContentProps } from './types';

export const StyledAlignContent = styled.div<AlignContentProps>(
    ({ textColor }) => ({
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        color: textColor,
        [`${StyledText}, ${StyledRichText}, p`]: {
            color: 'inherit',
            maxWidth: 500,
        },
    }),
    switchProp('alignment', {
        left: {
            alignItems: 'flex-start',
        },
        right: {
            alignItems: 'flex-end',
            textAlign: 'right',
        },
        center: {
            alignItems: 'center',
            textAlign: 'center',
        },
    }),
    switchProp('position', {
        top: {
            justifyContent: 'flex-start',
        },
        center: {
            justifyContent: 'center',
        },
        bottom: {
            justifyContent: 'flex-end',
        },
    }),
);
